import React from 'react';
import { Empty } from 'antd';
const EmptyData = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
export default EmptyData;